module.exports = __webpack_public_path__ + "images/22.450e8e03.png";